import util from "@bmp-vue/core/api/util";

const controller = "Rrc0035";
export default Object.assign({}, util.GetCrud(controller, [""]), {
    ValidarRegistro: function(dto) {
        return util.Axios.Post(
            controller + "/Validar",
            dto
        );
    },
    Incluir: function(identdOp, dto) {
        return util.Axios.Post(
            controller + "/domicilio" + `/${identdOp}`,
            dto
        );
    },
    IncluirArquivo: function(dto, identEmissorPrincipal, identEmissorAdm) {
        const url = `${process.env.VUE_APP_ROOT_API}${controller}/domicilio/Importar`;
        const config = {
            headers: {
                'identEmissorPrincipal': identEmissorPrincipal,
                'identEmissorAdm': identEmissorAdm
            }
        };

        return  util.Axios.Dynamic('post', url, dto, config);
    },
    GetRespostaSincronaByCodigo: function(codigo) {
        return util.Axios.GetAll(controller + `/${codigo}/RespostaSincrona`)
    },
    GetRespostaRegistroByCodigo: function(codigo) {
        return util.Axios.GetAll(controller + `/${codigo}/RespostaRegistro`)
    }
});